export default __webpack_public_path__ + "static/media/az.a549c87c.png";